import { defineMessages } from "react-intl";

export const messages = defineMessages({
  allCategories: {
    id: "1X6HtI",
    defaultMessage: "All Categories",
  },
  createCategory: {
    id: "vof5TR",
    defaultMessage: "Create category",
    description: "button",
  },
  searchCategory: {
    id: "T83iU7",
    defaultMessage: "Search categories...",
  },
  bulkCategoryDelete: {
    defaultMessage: "Delete categories",
    id: "FiO/W/",
  },
  bulkCategoryDuplicate: {
    defaultMessage: "Duplicate categories",
    id: 'NtjoO2',
  },
});
